import { Pipe, PipeTransform } from '@angular/core';
import { FilterOperator } from '@vendasta/crm';
import { UnaryOperators } from '../../constants';

@Pipe({ name: 'operatorValueIsRequired' })
export class OperatorValueIsRequiredPipe implements PipeTransform {
  transform(value?: FilterOperator | null): boolean {
    if (!value) {
      return false;
    }
    return !UnaryOperators.includes(value);
  }
}
